import { Badge } from './Badge';
import type { ChannelWithId } from '../lib/data';
import { deriveChannelStatus, resumeCountdown } from '../lib/status';
import { timeAgo } from '../lib/format';

/**
 * One channel's status tile. All text — channel names, reasons, excerpts — renders
 * as escaped JSX text (never dangerouslySetInnerHTML), so Intercom-derived markup
 * is inert (U10 security).
 */
export function StatusCard({
  channel,
  nowMs,
  onOpen,
}: {
  channel: ChannelWithId;
  nowMs: number;
  onOpen?: (channel: ChannelWithId) => void;
}) {
  const status = deriveChannelStatus(channel, nowMs);
  const countdown = resumeCountdown(channel, nowMs);
  return (
    <button className="status-card" onClick={() => onOpen?.(channel)} data-state={status.state}>
      <div className="status-card-head">
        <span className="channel-name">{channel.displayName}</span>
        <Badge tone={status.tone}>{status.label}</Badge>
      </div>
      <div className="status-card-meta">
        <span>last check: {timeAgo(channel.health.lastCheckCompletedAt, nowMs)}</span>
        <span>every {channel.frequencyMinutes}m · threshold {channel.thresholdMinutes}m</span>
        {countdown && <span className="countdown">{countdown}</span>}
      </div>
    </button>
  );
}
